import React, { Component } from 'react';
import { connect } from 'react-redux';
import { lighten, makeStyles, withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import { getPipelineProsByAfid,setofUpdatedashboard } from 'actions'
import {isEmpty} from 'lodash'
import {NumberFormat} from 'components/NotyNumberFormat'
import Skeleton from '@material-ui/lab/Skeleton';

function mapStateToProps({auth,DashBoard,accountsData}) {
    const { authUser} = auth;
    const { updatedashboard,DashBoardValueOf} = accountsData;
    const { ProspektPipeline,DashboardProspektFilterOption} = DashBoard;
    return {
        authUser,ProspektPipeline,DashboardProspektFilterOption,
        updatedashboard,DashBoardValueOf
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getPipelineProsByAfid: (Afid,userid,FilterOption) => dispatch(getPipelineProsByAfid(Afid,userid,FilterOption)),
        setofUpdatedashboard: () => dispatch(setofUpdatedashboard()),
        dispatch
    }
}

const BorderLinearProgress = withStyles({
    root: {
        width:'100%',
        height: 7,
        borderRadius: 20,
        backgroundColor: '#12585E',
    },
    bar: {
        borderRadius: 20,
        backgroundColor: '#93F8B3',
    },
})(LinearProgress);

const data = [
    {
        id: 1,
        name: 'KONTAKTAD',
        value: '870K',
        progress:
            <div >
                <BorderLinearProgress
                    variant="determinate"
                    // color="#075a5f"
                    value={87}
                />
            </div>
    },
    {
        id: 2,
        name: 'BOKAT MÖTE',
        value: '700k',
        progress:
            <div >
                <BorderLinearProgress
                    variant="determinate"
                    // color="#075a5f"
                    value={70}
                />
            </div>
    },
    {
        id: 3,
        name: 'OFFERT',
        value: '630K',
        progress:
            <div >
                <BorderLinearProgress
                    variant="determinate"
                    // color="#075a5f"
                    value={63}
                />
            </div>
    },
    {
        id: 4,
        name: 'AVTAL',
        value: '530K',
        progress:
            <div >
                <BorderLinearProgress
                    variant="determinate"
                    // color="#075a5f"
                    value={53}
                />
            </div>
    },
    {
        id: 5,
        name: 'FAKTURERING',
        value: '320k',
        progress:
            <div >
                <BorderLinearProgress
                    variant="determinate"
                    // color="#075a5f"
                    value={32}
                />
            </div>
    },
];

class Pipeline extends Component {
    state={
        SalTabel:0,
        DashboardProspektFilterOption:parseInt(this.props.Kontor) === 0?[]:[{Meta:"Kontor",Value:this.props.Kontor}],
        done: false
    }
    intervalID = null
    componentDidMount=()=>{
        const Afid = this.props.Afid;
        
        this.props.getPipelineProsByAfid(Afid,undefined,this.state.DashboardProspektFilterOption).then(() => { 
            this.initiateInterval()
            this.setState({done: true})
         })         
    }
    initiateInterval () {
        clearInterval(this.intervalID);
        this.intervalID = null 
        this.intervalID = setInterval(
            () => {
                if(this.state.done === true){ 
                    this.setState({ done:false })
                    const Afid = this.props.Afid;
                    this.props.getPipelineProsByAfid(Afid,undefined,this.state.DashboardProspektFilterOption).then(() => { 
                        this.initiateInterval()
                        this.setState({done: true})
                     })
                }
            },
            180000
        );
      }
    componentWillUnmount() {
        clearInterval(this.intervalID);
        this.intervalID = null
    }
    componentDidUpdate=()=>{
        const Afid = this.props.Afid;
        if(parseInt(this.props.updatedashboard) === 1){
            this.props.getPipelineProsByAfid(Afid,undefined,this.state.DashboardProspektFilterOption).then(() => { 
                this.initiateInterval()
                this.setState({done: true})
             })
             this.props.setofUpdatedashboard()
        }
        if(this.props.DashboardProspektFilterOption !== this.state.DashboardProspektFilterOption && !isEmpty(this.props.DashboardProspektFilterOption))
        {
             console.log("DDDDDDDDDDDDDDDDDDAAAAAAAAAAAAAAAAA")
            
            this.props.getPipelineProsByAfid(Afid,undefined,this.state.DashboardProspektFilterOption).then(() => { 
                this.initiateInterval()
                this.setState({done: true})
             }) /**/
            this.setState({
                DashboardProspektFilterOption:this.props.DashboardProspektFilterOption 
            }) 
        }
    }
    getDashBoardValueOf = ()=>{
        try{
        let ModuleValue = JSON.parse(this.props.DashBoardValueOf).find(item=>parseInt(item.DashBaord) === 2)
        if(ModuleValue.Value > 2 && ModuleValue.Value !== 5){
            return 2
        }else{
            return 1
        }
    }
    catch(error){return 1}
    }
    formatNumber2=(number)=>{
        const _ValueOF = this.getDashBoardValueOf()
        return NumberFormat(number, _ValueOF === 2?'total':this.props.Flags?.DashboardRoundoff === 0 ? 'standard' : 'compact', _ValueOF === 2?'default':'auto', 0)
    }
    formatNumber=(number)=>{
        const _ValueOF = this.getDashBoardValueOf()
        return NumberFormat(number, _ValueOF === 2?'total':this.props.Flags?.DashboardRoundoff === 0 ? 'standard' : 'compact', _ValueOF === 2?'default':'auto', 0)
    }
    getTotal=()=>{
        if(isEmpty(this.props.ProspektPipeline)){return 1}
        else{
            let total = 0;
            this.props.ProspektPipeline.map(item=>{
                total += parseInt(item.Varde)
            })
        
        console.log(total,"Asd")
        return total
        }
    }
    render() {
        const total = this.getTotal()
        return (
            <div>
            {
                 this.state.done === false?  
                 <>
                 <div className="row mx-1">
                     <div className="col-12 row mx-1">
                         <Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                     </div>
                     <div className="col-12 mx-0" style={{marginBottom: this.props.isFrom === 1 ? '1rem' : '0.7rem'}}></div>
                     <div className="col-12 m-0" >
                     <Skeleton variant="rectangular" height={10} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                     </div>   
                 </div>
                 <div className="row mx-1">
                     <div className="col-12 row mx-1">
                         <Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                     </div>
                     <div className="col-12 mx-0" style={{marginBottom: this.props.isFrom === 1 ? '1rem' : '0.7rem'}}></div>
                     <div className="col-12 m-0" >
                     <Skeleton variant="rectangular" height={10} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                     </div>   
                 </div>
                 <div className="row mx-1">
                     <div className="col-12 row mx-1">
                         <Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                     </div>
                     <div className="col-12 mx-0" style={{marginBottom: this.props.isFrom === 1 ? '1rem' : '0.7rem'}}></div>
                     <div className="col-12 m-0" >
                     <Skeleton variant="rectangular" height={10} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                     </div>   
                 </div>
                 </>
                 :
            isEmpty(this.props.ProspektPipeline)?"":
            this.props.ProspektPipeline.map((object) =>
                <div className="row mx-1">
                    <div className="col-12 row mx-1">
                        <div style={{margin:'0', fontSize:16}} className="col-7 text-left">
                            {object.FasNamn}
                        </div>
                        <div style={{margin:'0', fontSize:16}} className="col-5 text-right">
                            {/* {object.Varde} */}
                            {this.formatNumber(object.Varde)}
                        </div>
                    </div>
                    <div className="col-12 mx-0" style={{marginBottom: this.props.isFrom === 1 ? '2rem' : '0.7rem'}}>
                    <div className="col-12 m-0" >
                        <BorderLinearProgress
                            variant="determinate"
                            // color="#075a5f"
                            value={(object.Varde/total)*100 > 100 ? 100 : (object.Varde/total)*100}
                        />  
                    </div>
                        
                    </div>
                </div>
            )}
        </div>
        );
    }
}

export default connect(
    mapStateToProps,mapDispatchToProps
)(Pipeline);
